import React, { FC } from 'react';
import MapMarker from 'js/components/MapObjects/MapMarker';
import polygonSvgEdit from 'style/images/drawing/edit_location.svg';

interface MarkerData {
  position: google.maps.LatLngLiteral;
  icon?: google.maps.Icon | { url: string };
}

interface SelectedMarkerProps {
  marker?: MarkerData | null;
}

const SelectedMarker: FC<SelectedMarkerProps> = ({ marker }) => {
  if (!marker) return null;

  const icon: google.maps.Icon | { url: string } = marker.icon || { url: polygonSvgEdit };

  return <MapMarker position={marker.position} icon={icon} />;
};

export default SelectedMarker;
